<template>
  <div class="index-page">
    <div class="logo-wrap">
      <img src="@/assets/images/logo.png" class="logo">
      <h1>飞飞盘搜索</h1>
    </div>
    <div class="form-wrap">
      <div class="search-form">
        <input autocomplete="off" type="text" v-model="keyword" placeholder="请输入你要搜索的关键词" @click.stop="" @keyup.enter="submit" autofocus class="input">
        <span class="search-button" @click="submit"> </span>
      </div>
    </div>
    <!-- <div class="ad-wrap" v-if="ads.length > 0">
       <template v-for="item in ads">
        <div class="ad-item" v-if="item.isIndex" :key="item.url">
          <a :href="item.url" target="_blank"><img :src="item.img"></a>
        </div>
      </template>
    </div>
    <div class="group-wrap" v-if="groups.length > 0">
      <template v-for="item in groups">
        <div 
          class="group-item" 
          :class="{'active': item.name == currentName}" 
          :key="item.name" 
          @click="chooseGroup(item.name)"
        >
          <img :src="item.icon" class="group-icon">
          <p>{{item.name}}</p>
          <div class="hover-tip" >
            <p class="text">微信扫码加群</p>
            <img :src="item.img" alt="微信群二维码">
          </div>
        </div>
      </template>
    </div> -->
    <hot class="hot-wrap" />
  </div>
</template>

<script>
import Hot from '@/components/Hot'
// import Hongbao from '@/components/Hongbao'
// import { getGroupInfo, getAdsInfo } from '@/api/search'

export default {
  data () {
    return {
      ads: [],
      groups: [],
      keyword: '',
      currentName: '',
      isFrame: false,
    }
  },
  components: {
    Hot,
    // Hongbao,
  },
  async mounted() {
    // const [data, groups] = await Promise.all([
    //   getAdsInfo(),
    //   getGroupInfo()
    // ])
    // this.groups = groups
    //  this.ads = data.filter((item) => {
    //   return item.isIndex
    // })

    if (window.self != window.top) {
      this.isFrame = true
    }
  },
  methods: {
    chooseGroup (name) {
      if (this.currentName == name) {
        this.currentName = ''
      } else {
        this.currentName = name
      }
    },
    submit () {
      if (this.isFrame) {
          return this.openWindow(`${window.location.origin}/#/main/search?keyword=${encodeURIComponent(this.keyword)}`, true)
        }
        return window.location.href = `${window.location.origin}/#/main/search?keyword=${encodeURIComponent(this.keyword)}`
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_var.scss";
.index-page {
  padding-top: 80px;
}

.logo-wrap {
  text-align: center;
  display: flex;
  align-items: center;
  margin-bottom: 40px;
  justify-content: center;
  .logo {
    height: 36px;
    margin-right: 10px;
  }
  h1 {
    display: inline-block;
    color: $theme-color;
    font-size: 28px;
  }
}

.form-wrap {
  max-width: 540px;
  margin: 20px auto;
  .search-form {
    position: relative;
    display: inline-block;
    width: 100%;
    .input {
      width: 100%;
      font-size: 13px;
      height: 42px;
      padding-left: 20px;
      padding-right: 50px;
      outline: none;
      border: 1px solid #ddd;
      transition: all ease 0.3s;
      &:focus {
        border-color: $theme-color;
      }
    }
    .search-button {
      display: inline-block;
      position: absolute;
      bottom: 5px;
      width: 50px;
      right: 5px;
      top: 5px;
      z-index: 2;
      outline: none;
      border: none;
      cursor: pointer;
      background-color: $theme-color;
      transition: all ease 0.2s;
      background: $theme-color url('../assets/images/search.png') no-repeat center center;
      background-size: 16px 16px;
      &:hover {
        background-color: darken($theme-color, 5%);
      }
      &:active {
        background-color: darken($theme-color, 10%);
      }
    }
  }
}

.ad-wrap {
  display: flex;
  justify-content: space-around;
  .ad-item {
    border-radius: 4px;
    overflow: hidden;
    width:240px;
    font-size: 0;
    img {
      width: 100%;
      height: auto;
      border-radius: 4px;
    }
  }
}

.hot-wrap, .ad-wrap{
  max-width: 820px;
  margin: 20px auto;
}

.hongbao-wrap {
  text-align: center;
  .hongbao {
    width:375px; 
    height: 434px;
    margin: auto; 
    zoom: 0.45;
    display: inline-block;
    margin-right: 15px;
  }
  .ad {
    height: 175px;
    display: inline-block;
    img {
      height: 100%;
      border-radius: 4px;
    }
  }
}

.group-wrap {
  display: flex;
  width: $theme-width;
  max-width: 100%;
  margin: 20px auto;
  justify-content: center;
  flex-wrap: wrap;
  .group-item {
    padding: 10px;
    display: flex;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    position: relative;
    background-color: #f8f8f8;
    border: 1px solid #eee;
    border-radius: 4px;
    font-size: 12px;
    margin-right: 10px;
    &:last-child {
      margin-right: 0;
    }
    .group-icon {
      width: 24px;
      height: 24px;
      margin-right: 8px
    }
    &:hover, &.active {
      .hover-tip {
        visibility: visible;
        opacity: 1;
        bottom: 55px;
      }
    }
    .hover-tip {
      width: 200px;
      padding: 10px;
      display: flex;
      visibility: hidden;
      opacity: 0;
      flex-direction: column;
      align-items: center;
      position: absolute;
      text-align: center;
      border-radius: 4px;
      z-index: 100;
      right: 50%;
      transform: translateX(50%);
      bottom: 100px;
      border: 1px solid #eee;
      background-color: #fff;
      transition: all ease 0.2s 0.1s;
      box-shadow: 2px 2px 14px 0 rgba(0,0,0,0.05), -2px -2px 14px 0 rgba(0,0,0,0.05);
      &:after {
        content: '';
        width: 0;
        height: 0;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: -8px;
        z-index: -1;
        border-left: 6px solid transparent;
        border-top: 8px solid #eee;
        border-right: 6px solid transparent;
      }
      &:before {
        content: '';
        width: 0;
        height: 0;
        position: absolute;
        bottom: -6px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 1;
        border-left: 6px solid transparent;
        border-top: 8px solid #fff;
        border-right: 6px solid transparent;
      }
      .text {
        font-weight: bold;
        color: #333;
      }
      img {
        width: 180px;
      }
    }
  }
}

@media (max-width: 700px) {
  .index-page {
    padding-top: 20px;
  }
  .ad-wrap {
    align-items: center;
    flex-direction: column;
    .ad-item {
      width: 80%;
      margin-bottom: 15px;
      height: auto;
    }
  }
  .hongbao-wrap {
    .ad {
      display: none;
    }
  }
  .logo-wrap, .hot-wrap, .form-wrap, .group-wrap {
    margin-top: 20px;
    margin-bottom: 20px;
    padding: 0 10px;
  }
  .group-wrap {
    justify-content: space-around;
    .group-item {
      margin-bottom: 10px;
      &:nth-child(2n) {
        .hover-tip {
          right: 0;
          transform: translateX(0);
        }
      }
      &:nth-child(2n + 1) {
        .hover-tip {
          left: 0;
          transform: translateX(0);
        }
      }
    }
  }
}
</style>
